import { render, staticRenderFns } from "./UnpublishModal.vue?vue&type=template&id=5c27d25e&scoped=true"
import script from "./UnpublishModal.vue?vue&type=script&lang=js"
export * from "./UnpublishModal.vue?vue&type=script&lang=js"
import style0 from "./UnpublishModal.vue?vue&type=style&index=0&id=5c27d25e&prod&lang=scss&scoped=true"
import style1 from "./UnpublishModal.vue?vue&type=style&index=1&id=5c27d25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c27d25e",
  null
  
)

export default component.exports